// components/ConfirmDialog.jsx
import React from "react";

const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-dry border border-yellowlight rounded-2xl p-6 w-[90%] max-w-md shadow-xl text-text py-8">
        <h3 className="text-lg mb-4 pb-12">{message}</h3>
        <div className="border-t border-textGray pb-4"></div>
        <div className="flex justify-ed gap-4">
          <button
            onClick={onCancel}
            className="w-full px-5 py-2 rounded-xl bg-gray-700 hover:bg-gray-600"
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="w-full px-5 py-2 rounded-xl bg-red-600 hover:bg-red-700"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
